define('Responsive/controllers/VerticalViewController',['require','exports','module','./ViewController','../util/dom'],function(require,exports,module){
    var ViewController = require( './ViewController' ),
        ReDom = require( '../util/dom' ),
        doc = document;
    // Add private variables here
    var Superclass;
    // Add private methods here
    function isFlexHeight(height){
        if(height && height!="" && height.indexOf("%")>-1 ) return true;
        else return false;
    }
    function isStaticHeight(height){
        if(height && height!="" && ( height.indexOf("px")>-1 || height.indexOf("%")<0 ) ) return true;
        else return false;
    }

    // Constructor
    function VerticalViewController(){
        // Call super constructor
        Superclass.constructor.call(this);
        this.childControllerDesc = {};
        this.flexHeightChildControllers = [];

        // FYI... this.viewPortFlexHeight - this.pixelHeightOffset = available height for % based views
        this.viewPortFlexHeight = 0; // used to figure out view port height for % based views
        this.pixelHeightOffset = 0; // used to track height offset of static height views
    }

    // Prototype Inheritence
    ViewController.spawn(VerticalViewController).define({
        loadView : function() {
            Superclass.loadView.call(this);
            this.setClassName("VerticalViewController");
            this.view.style.position='relative';
            this.view.style.overflowX='hidden';
        },

        addChildController : function(name, controller, height){
            if(height==="auto"){
                height="100%";
            }
            this.childControllerDesc[name] = {
                "name" : name,
                "controller" : controller,
                "isDrawn" : false,
                "enabled" : true,
                "height" : height,
                "container" : doc.createElement('div')
            };
            this.childControllerDesc[name].container.className="Vertical-panel";
            this.childControllerDesc[name].container.setAttribute("data-panel-name",name);
            if( isStaticHeight(height) ){
                this.pixelHeightOffset += parseInt(height,10);
            }
            else if( isFlexHeight(height)){
                this.flexHeightChildControllers.push(name);
            }
            controller.parentViewController = Object.create(this);
            controller.parentViewController.view=this.childControllerDesc[name].container;

            this.childViewControllers.push(controller);
            return this;
        },
        disable : function(name){
            if(this.childControllerDesc[name].enabled!==true){return;}
            var height = this.childControllerDesc[name].height;
            this.childControllerDesc[name].enabled = false;
            if( isStaticHeight(height) ){
                this.pixelHeightOffset -= parseInt(height,10);
            }
            
        },
        enable : function(name){
            if(this.childControllerDesc[name].enabled===true){return;}
            var height = this.childControllerDesc[name].height;
            this.childControllerDesc[name].enabled = true;
            this.childControllerDesc[name].isDrawn = false;
            if( isStaticHeight(height) ){
                this.pixelHeightOffset += parseInt(height,10);
            }
        },
        setAvailableHeight : function(){
            Superclass.setAvailableHeight.call(this,"VerticalViewController");
            // return;
            var i=0, len = this.flexHeightChildControllers.length, viewController, height, 
                curHeight=this.availableHeight;

            if(curHeight!=='auto'){
                if(this.pixelHeightOffset){
                    curHeight=curHeight - this.pixelHeightOffset;
                }
                // this.viewPortFlexHeight = curHeight;
                for(; i<len; i++){
                    viewController = this.childControllerDesc[this.flexHeightChildControllers[i]];
                    if(viewController.enabled) {
                        height = viewController.height;
                        var percentageAsNumber = (height=="") ? 1 : parseInt(height,10)/100;
                        if(percentageAsNumber==0 ||!viewController.controller.isViewLoaded()) continue;
                        viewController.controller.parentViewController.availableHeight=curHeight * percentageAsNumber;
                        viewController.container.style.height = viewController.controller.parentViewController.availableHeight + "px";
                    }
                }
            }else{
                ReDom.removeStyleProperty(this.view,'height');
                for(; i<len; i++){
                    viewController = this.childControllerDesc[this.flexHeightChildControllers[i]];
                    delete viewController.controller.parentViewController.availableHeight;
                    // viewController.container.style.height = viewController.height;
                    ReDom.removeStyleProperty(viewController.container,'height');
                }

            }           
        },
        draw : function() {
            Superclass.draw.call(this);
            var controllerName, controllerDesc, controller, controllerView, viewPort;
            // this.setAvailableHeight();
            // this.viewPortFlexHeight = this.availableHeight - this.pixelHeightOffset; // fresh copy

            for(controllerName in this.childControllerDesc){
                controllerDesc = this.childControllerDesc[controllerName];
                controller = controllerDesc.controller;
                
                if(controllerDesc.enabled){
                    controller.viewWillAppear();
                    controllerView = controller.getView();
                    //controller must be attached before viewWillAppear
                    controllerView.style.visibility="hidden";
                    this.getView().appendChild( controllerDesc.container );
                    controllerDesc.container.appendChild(controllerView)
                    if(isStaticHeight(controllerDesc.height)){
                        controllerDesc.container.style.height = controllerDesc.height;
                        controller.parentViewController.availableHeight=parseInt(controllerDesc.height,10);

                        // controller.availableHeight=controllerDesc.height;
                    }
                    controllerView.style.visibility="visible";
                    controllerDesc.isDrawn = true;
                    controller.viewDidAppear();
                }
                else{
                    if(controllerDesc.isDrawn){
                        controllerView = controller.getView();

                        controllerDesc.isDrawn = false;
                        controller.viewWillDisappear();
                        ReDom.removeNode(controllerDesc.container,controllerView);                      
                        ReDom.removeNode(this.getView(),controllerDesc.container);
                        controller.viewDidDisappear();
                        controller.viewDidUnload();
                    }
                }
            }
            // this.setAvailableHeight();
            this.checkHeight();
        }
    });
    Superclass=VerticalViewController.superclass;

    return VerticalViewController;

});
